import AccordionDetails from '@mui/material/AccordionDetails';
import Stack from '@mui/material/Stack';
import Participant from '../Participant';
import { useCompetitor } from './AccordionCompetitor';

export const AccordionDetailsCompetitor: React.FC = () => {
  const { teamMax, participants } = useCompetitor();
  return (
    <AccordionDetails sx={{ p: 0 }}>
      <Stack>
        {participants.slice(0, teamMax).map((competitor, idx) => {
          return (
            <Participant
              {...competitor}
              key={'username' in competitor ? competitor.username : idx}
            />
          );
        })}
      </Stack>
    </AccordionDetails>
  );
};
